


























import Vue from 'vue';
import Component from 'vue-class-component';
import _ from 'lodash';
import helper from '@/services/helper.ts';
import { mapGetters, mapState } from 'vuex';
import api from '@/services/api';
import Q from 'q';
import { Prop } from 'vue-property-decorator';

export type ConfirmCallback = (id: string) => boolean;

@Component<SendPasswordModal>({
  computed: {
    ...mapState({
      CommitteeEmail: 'CommitteeEmail',
    }),
  },
})
export default class SendPasswordModal extends Vue {
  public email: string = '';
  public mobile: string = '';
  public Id: string = '';

  @Prop() protected readonly name!: string;
  @Prop() protected readonly onConfirm!: ConfirmCallback;

  get mode() {
    if (this.mobile && this.email) return 'sms_email';
    else if (this.mobile) return 'sms';
    else if (this.email) return 'email';
    else return null;
  }

  protected readonly CommitteeEmail!: string;

  get canSave() {
    return this.email || this.mobile;
  }

  public beforeOpen(event: any) {
    const param = event.params;
    this.email = param?.Email || '';
    this.mobile = param?.Mobile || '';
    this.Id = param?.Id || '';
  }

  get emailLink() {
    return `<a href="mailto:${this.CommitteeEmail}">${this.CommitteeEmail}</a>`;
  }

  public async onConfirmClick() {
    if (!(await this.onConfirm(this.Id))) return;
    await Q.delay(100);
    this.$modal.hide(this.name);
  }
}
